let environment = {
    production: false,
    url: 'https://newnuvalid-dev.tx.puntosalud.ar/api/v1/nuvalid',
    urlturnea: 'https://app.dev.turnea.com.ar',
    urlNuvalidLite: 'https://mpos-dev.tx.puntosalud.ar/api/v1/mposbackend'
};

let environmentReceta = {
    production: false,
    url: '/api/v1',
};

export { environment, environmentReceta };
